import React, { Component } from 'react';
import ResponsiveEmbed from 'react-responsive-embed';
import { obtenirDocument, obtenirDocumentArc, afficherFichier } from '../App_Code/API';
import Chargement from './Chargement';
import Card from './Card';

const ListeDocuments = ({ Fichiers, Actif, ChangerFichierActif }) => (
    <div className="list-group">
        <div className="list-group-item list-group-item-action">Documents</div>
        {Fichiers.map((fichier, i) => (
            <button
                className={`list-group-item list-group-item-action text-truncate ${Actif === i ? 'active' : ''}`}
                key={i}
                data-toggle="tooltip"
                data-placement="right"
                title={fichier.Nom}
                onClick={() => ChangerFichierActif(i)}
            >
                {fichier.Nom}
            </button>
        ))}
    </div>
);

const DocumentLocal = ({ location, history }) => {
    if (!location.state || !location.state.URI) {
        const chemin = location.pathname.slice(1).split('/');
        history.push(chemin && chemin[0] ? `/${chemin[0]}` : '/');
        return null;
    }

    return <ResponsiveEmbed src={location.state.URI} />;
};

class DocumentEnligne extends Component {
    constructor(props) {
        super(props);

        let lsFichiers = null;
        if (this.props.location.state && this.props.location.state.Token) {
            lsFichiers = [
                {
                    URL: afficherFichier(this.props.location.state.Token),
                },
            ];
        }

        this.state = {
            Fichiers: lsFichiers,
            Actif: 0,
        };
    }

    componentDidMount() {
        if (!this.props.location.state) {
            const chemin = this.props.location.pathname.slice(1).split('/');
            this.props.history.push(chemin && chemin[0] ? `/${chemin[0]}` : '/');
            return;
        }
        if (this.state.Fichiers) return;

        const { Id } = this.props.location.state;
        obtenirDocument(Id).then((data) => {
            const lsFichiers = [];
            data.LsFichiers.forEach((element, i) => {
                lsFichiers.push({
                    Nom: element.Nom || `Fichier sans nom n°${i + 1}`,
                    URL: afficherFichier(element.Token),
                });
            });
            this.setState({ Fichiers: lsFichiers });
        });
    }

    ChangerFichierActif = (indiceFichier) => {
        this.setState({ Actif: indiceFichier });
    };

    render() {
        if (!this.state.Fichiers) return <Chargement />;

        if (this.state.Fichiers.length <= 1) {
            return <ResponsiveEmbed src={this.state.Fichiers[0].URL} />;
        }

        return (
            <div className="row">
                <div className="col-xl-2 col-sm-12 col-md-6">
                    <ListeDocuments
                        Fichiers={this.state.Fichiers}
                        Actif={this.state.Actif}
                        ChangerFichierActif={this.ChangerFichierActif}
                    />
                </div>
                <div className="col-xl-10 col-sm-12 col-md-6">
                    <Card>
                        <ResponsiveEmbed src={this.state.Fichiers[this.state.Actif].URL} />
                    </Card>
                </div>
            </div>
        );
    }
}


class DocumentArcEnligne extends Component {
    constructor(props) {
        super(props);

        let lsFichiers = null;
        if (this.props.location.state && this.props.location.state.Token) {
            lsFichiers = [
                {
                    URL: afficherFichier(this.props.location.state.Token),
                },
            ];
        }

        this.state = {
            Fichiers: lsFichiers,
            Actif: 0,
        };
    }

    componentDidMount() {
        if (!this.props.location.state) {
            const chemin = this.props.location.pathname.slice(1).split('/');
            this.props.history.push(chemin && chemin[0] ? `/${chemin[0]}` : '/');
            return;
        }
        if (this.state.Fichiers) return;

        const { Id } = this.props.location.state;
        
        obtenirDocumentArc(Id).then((data) => {
            const lsFichiers = [];          
            data.LsFichiers.forEach((element, i) => {
                lsFichiers.push({
                    Nom: element.Nom || `Fichier sans nom n°${i + 1}`,
                    URL: afficherFichier(element.Token),
                });
            });
            this.setState({ Fichiers: lsFichiers });
        });
    }

    ChangerFichierActif = (indiceFichier) => {
        this.setState({ Actif: indiceFichier });
    };

    render() {
        if (!this.state.Fichiers) return <Chargement />;

        if (this.state.Fichiers.length <= 1) {
            return <ResponsiveEmbed src={this.state.Fichiers[0].URL} />;
        }

        return (
            <div className="row">
                <div className="col-xl-2 col-sm-12 col-md-6">
                    <ListeDocuments
                        Fichiers={this.state.Fichiers}
                        Actif={this.state.Actif}
                        ChangerFichierActif={this.ChangerFichierActif}
                    />
                </div>
                <div className="col-xl-10 col-sm-12 col-md-6">
                    <Card>
                        <ResponsiveEmbed src={this.state.Fichiers[this.state.Actif].URL} />
                    </Card>
                </div>
            </div>
        );
    }
}


export { DocumentLocal, DocumentEnligne, DocumentArcEnligne };



// WEBPACK FOOTER //
// ./src/components/PageDocument.js